module.exports = __webpack_public_path__ + "static/media/ArrowDown.a6d6c954.svg";